<template>
  <div class="section-playback-timeline">
    <Section class="section-no-border">
      <div class="section-header" slot="header">
        <h1 class="title">Timeline</h1>
      </div>
      <div class="section-body">
        <div class="timeline-container">
          <div class="timeline-body">
            <div class="event-container event-header">
              <div class="event-timeline-container">
                <div class="event-date">
                  <div class="timeline" v-for="(event, index) in timelineRageDateTime()" :key="index">
                    {{formatShortDate(event)}}
                  </div>
                </div>
                <div class="event-time">
                  <div class="timeline" v-for="(event, index) in timelineRageDateTime()" :key="index">
                    {{formatTime(event)}}
                  </div>
                </div>
              </div>
            </div>
            <div class="event-container-body">
              <div class="event-container event-all">
                <div class="event-type" />
                <div class="event-timeline">
                  <div class="timeline" />
                </div>
              </div>
              <div class="event-container event-buffer">
                <div class="event-type">
                  <div class="title" title="พฤติกรรมเล่นของ Video ที่เกิดการหมุน">Buffering</div>
                </div>
                <div class="event-timeline">
                  <span v-if="!isEventsGroupKeyEmpty(eventsIdGroupKey['playback.buffering_start'])">
                    <EventTimelineItem
                      class="timeline"
                      v-for="(event, index) in eventsIdGroupKey['playback.buffering_start']"
                      :data="getEventById(event)"
                      :key="index" />
                  </span>
                  <div
                    class="text-message"
                    v-if="isEventsGroupKeyEmpty(eventsIdGroupKey['playback.buffering_start'])">
                    ไม่มี Buffer
                  </div>
                </div>
              </div>
              <div class="event-container event-seeking">
                <div class="event-type">
                  <div class="title" title="เลื่อนตำแหน่งการดูจากจุดนึงไปยังจุดนึง">Seeking</div>
                </div>
                <div class="event-timeline">
                  <span v-if="!isEventsGroupKeyEmpty(eventsIdGroupKey['playback.seeking_start'])">
                    <EventTimelineItem
                      class="timeline"
                      v-for="(event, index) in eventsIdGroupKey['playback.seeking_start']"
                      :data="getEventById(event)"
                      :key="index" />
                  </span>
                  <div
                    class="text-message"
                    v-if="isEventsGroupKeyEmpty(eventsIdGroupKey['playback.seeking_start'])">
                    ไม่มีการ Seek
                  </div>
                </div>
              </div>
              <div class="event-container event-error">
                <div class="event-type">
                  <div class="title" title="พบปัญหาในการเล่น">Error</div>
                </div>
                <div class="event-timeline">
                  <span v-if="!isEventsGroupKeyEmpty(eventsIdGroupKey['playback.error'])">
                    <EventTimelineItem
                      class="timeline"
                      v-for="(event, index) in eventsIdGroupKey['playback.error']"
                      :data="getEventById(event)"
                      :key="index" />
                  </span>
                  <div
                    class="text-message"
                    v-if="isEventsGroupKeyEmpty(eventsIdGroupKey['playback.error'])">
                    ไม่มี Error
                  </div>
                </div>
              </div>
              <div class="event-container event-graph-container event-resolution">
                <div class="event-type">
                  <div class="title">Resolution</div>
                </div>
                <div class="event-timeline"
                  :style="{ 'max-width': `${getPositionByTime(lastEvent)}%`}">
                  <div class="max-value"
                    v-if="!isEventsMetricEmpty(eventsByMetric.playback_resolution)">
                    Max : {{findMaxValue(eventsByMetric.playback_resolution)}}
                  </div>
                  <div id="graph-container" v-if="!isEventsMetricEmpty(eventsByMetric.playback_resolution)">
                    <VueApexCharts
                      type="area"
                      height="100"
                      :options="getChartOptionsByType('playback_resolution')"
                      :series="getSeriesByMetric(eventsByMetric.playback_resolution)">
                    </VueApexCharts>
                  </div>
                  <div
                    class="text-message"
                    v-if="isEventsMetricEmpty(eventsByMetric.playback_resolution)">
                    ไม่มีข้อมูล
                  </div>
                </div>
              </div>
              <div class="event-container event-graph-container event-bandwidth_estimate">
                <div class="event-type">
                  <div class="title">Bandwidth Estimate</div>
                  <small>(Mbit / sec)</small>
                </div>
                <div class="event-timeline"
                  :style="{ 'max-width': `${getPositionByTime(lastEvent)}%`}">
                  <div class="max-value"
                    v-if="!isEventsMetricEmpty(eventsByMetric.bandwidth_estimate)">
                    Max : {{getMaxOfEventMetricToMbitPerSec(eventsByMetric.bandwidth_estimate)}} (Mbit/ sec)
                  </div>
                  <div id="graph-container"
                    v-if="!isEventsMetricEmpty(eventsByMetric.bandwidth_estimate)">
                    <VueApexCharts
                      type="area"
                      height="100"
                      :options="getChartOptionsByType('bandwidth_estimate')"
                      :series="getSeriesByMetric(eventsByMetric.bandwidth_estimate)">
                    </VueApexCharts>
                  </div>
                  <div
                    class="text-message"
                    v-if="isEventsMetricEmpty(eventsByMetric.bandwidth_estimate)">
                    ไม่มีข้อมูล
                  </div>
                </div>
              </div>
              <div class="event-container event-graph-container event-buffer_health">
                <div class="event-type">
                  <div class="title">Buffer Health</div>
                  <small>(sec)</small>
                </div>
                <div class="event-timeline"
                  :style="{ 'max-width': `${getPositionByTime(lastEvent)}%`}">
                  <div class="max-value"
                    v-if="!isEventsMetricEmpty(eventsByMetric.buffer_health)">
                    Max : {{findMaxValue(eventsByMetric.buffer_health).toFixed(2)}} sec
                  </div>
                  <div id="graph-container" v-if="!isEventsMetricEmpty(eventsByMetric.buffer_health)">
                    <VueApexCharts
                      type="area"
                      height="100"
                      :options="getChartOptionsByType('buffer_health')"
                      :series="getSeriesByMetric(eventsByMetric.buffer_health)">
                    </VueApexCharts>
                  </div>
                  <div
                    class="text-message"
                    v-if="isEventsMetricEmpty(eventsByMetric.buffer_health)">
                    ไม่มีข้อมูล
                  </div>
                </div>
              </div>
              <div class="event-container event-graph-container event-response_time">
                <div class="event-type">
                  <div class="title">Respone Time</div>
                  <small>(sec)</small>
                </div>
                <div class="event-timeline"
                  :style="{ 'max-width': `${getPositionByTime(lastEvent)}%`}">
                  <div class="max-value"
                    v-if="!isEventsMetricEmpty(eventsByMetric.response_time)">
                    Max : {{findMaxValue(eventsByMetric.response_time).toFixed(2)}} sec
                  </div>
                  <div id="graph-container" v-if="!isEventsMetricEmpty(eventsByMetric.response_time)">
                    <VueApexCharts
                      type="area"
                      height="100"
                      :options="getChartOptionsByType('response_time')"
                      :series="getSeriesByMetric(eventsByMetric.response_time)">
                    </VueApexCharts>
                  </div>
                  <div
                    class="text-message"
                    v-if="isEventsMetricEmpty(eventsByMetric.response_time)">
                    ไม่มีข้อมูล
                  </div>
                </div>
              </div>
              <div class="event-container event-overlay"
                v-if="isShowLoadmore()"
                v-touch:swipe.prevent="loadMore">
                <div class="event-overlay-timeline">
                  <div class="overlay"  :style="{ left: `calc(${getPositionByTime(lastEvent)}%)`}">
                    <div class="content">
                      <button type="button" class="btn btn-link btn-load"
                        @click="$emit('onLoadmore')"
                        :title="'Load more event'">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <EmptyMessage v-if="isEmpty()">
          ไม่พบข้อมูล
        </EmptyMessage>
        <EmptyMessage v-if="isError()">
          <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
          <p>
            โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
            <a
              :href="`mailto:support@byteark.com`"
              target="_top"
            >support@byteark.com</a>
          </p>
          <span slot="code" class="code">
            error code : {{stateEventList.error.status || 'not found' }}
          </span>
        </EmptyMessage>
        <div v-if="stateEventList.isLoading" class="d-flex justify-content-center">
          <div class="spinner-border" role="status" />
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
/* eslint camelcase: "off" */
/* eslint arrow-body-style: "off" */
import _ from 'lodash';
import {
  differenceInMinutes,
  addMinutes,
  roundToNearestMinutes,
  setSeconds,
} from 'date-fns';
import { mapGetters } from 'vuex';
import VueApexCharts from 'vue-apexcharts';
import dateFormatter from '@/utils/dateFormatter';
import unitFormatter from '@/utils/unitFormatter';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import EventTimelineItem from '@/playback/EventTimelineItem.vue';

export default {
  mixins: [dateFormatter, unitFormatter],
  components: {
    VueApexCharts,
    Section,
    EmptyMessage,
    EventTimelineItem,
  },
  data() {
    return {
      scale: {
        date: 2,
        time: 5,
        maxTime: 10,
      },
      defaultChartOption: {
        chart: {
          type: 'area',
          height: 100,
          sparkline: {
            enabled: true,
          },
        },
        tooltip: {
          x: {
            show: false,
          },
        },
        stroke: {
          width: 1,
          curve: 'straight',
        },
        fill: {
          opacity: 0.3,
        },
        responsive: [{
          breakpoint: 576,
          options: {
            chart: {
              height: 42,
            },
          },
        }],
      },
    };
  },
  computed: {
    ...mapGetters(['eventIds',
      'stateEventList',
      'getEventById',
      'eventsIdGroupKey',
      'eventsByMetric',
      'playbackDuration',
      'currentPlayback',
      'firstEvent',
      'lastEvent']),
  },
  methods: {
    timelineRageDateTime() {
      if (this.currentPlayback) {
        const rangeDateTime = [];
        const startWatchingTime = new Date(this.currentPlayback.start_watching_time);
        const endWatchingTime = new Date(this.currentPlayback.end_watching_time);
        const differenceMinutes = differenceInMinutes(this.getRoundUpMinute(endWatchingTime), startWatchingTime);
        const amountPerSlot = differenceMinutes / this.scale.time;

        if (amountPerSlot >= 1) {
          for (let i = 0; i <= this.scale.time; i += 1) {
            const dateTimeItem = addMinutes(startWatchingTime, (amountPerSlot * i));
            rangeDateTime.push(dateTimeItem);
          }
          return rangeDateTime;
        }

        return [startWatchingTime, roundToNearestMinutes(endWatchingTime)];
      }
      return [];
    },
    getRoundUpMinute(dateTime) {
      const newDateTime = setSeconds(new Date(dateTime), 0);
      return addMinutes(new Date(newDateTime), 1);
    },
    getPositionByTime(event) {
      return (((event.client_timestamp - this.firstEvent.client_timestamp) / this.playbackDuration) * 100).toFixed(2);
    },
    getChartOptionsByType(type) {
      const resolutionOption = {
        tooltip: {
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: () => 'Resolution',
            },
          },
        },
        yaxis: {
          labels: {
            formatter: value => `${parseInt(value, 10)}p`,
          },
        },
        colors: ['#5613B5'],
      };

      const bandwidthEstimateOption = {
        tooltip: {
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: () => 'Bandwidth Estimate',
            },
          },
        },
        yaxis: {
          forceNiceScale: true,
          min: 0,
          labels: {
            formatter: value => `${this.transformBitToMbit(value)} (Mbit / sec)`,
          },
        },
        colors: ['#0097C1'],
      };

      const bufferHealthOption = {
        tooltip: {
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: () => 'Buffer Health',
            },
          },
        },
        yaxis: {
          forceNiceScale: true,
          decimalsInFloat: 2,
          min: 0,
          labels: {
            formatter: value => `${value.toFixed(2)} sec`,
          },
        },
        colors: ['#2a9d8f'],
      };

      const responseTimeOption = {
        tooltip: {
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: () => 'Response Time',
            },
          },
        },
        yaxis: {
          forceNiceScale: true,
          decimalsInFloat: 2,
          min: 0,
          labels: {
            formatter: value => `${this.transformMillisecToSec(value)} sec`,
          },
        },
        colors: ['#343967'],
      };

      switch (type) {
        case 'playback_resolution':
          return { ...this.defaultChartOption, ...resolutionOption };
        case 'bandwidth_estimate':
          return { ...this.defaultChartOption, ...bandwidthEstimateOption };
        case 'buffer_health':
          return { ...this.defaultChartOption, ...bufferHealthOption };
        case 'response_time':
          return { ...this.defaultChartOption, ...responseTimeOption };
        default:
          return this.defaultChartOption;
      }
    },
    getSeriesByMetric(eventMetric) {
      return [
        {
          data: eventMetric,
        },
      ];
    },
    isShowLoadmore() {
      return !this.stateEventList.isLoading && this.stateEventList.currentScrollId;
    },
    isEmpty() {
      if (this.eventIds.length > 0) {
        return false;
      }
      return this.stateEventList.isLoading
        && this.stateEventList.isEmpty
        && !this.stateEventList.isError;
    },
    isEventsGroupKeyEmpty(events) {
      return !(!_.isUndefined(events) && events.length > 0);
    },
    isEventsMetricEmpty(events) {
      return _.every(events, event => event === null);
    },
    findMaxValue(events) {
      return _.max(events);
    },
    getMaxOfEventMetricToMbitPerSec(events) {
      const max = _.max(events);
      return this.transformBitToMbit(max);
    },
    isError() {
      if (this.eventIds.length > 0) {
        return false;
      }
      return !this.stateEventList.isLoading && this.stateEventList.isError;
    },
    loadMore() {
      this.$emit('onLoadmore');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.section-playback-timeline {

  .section {
    .section-body {
      padding: 0;
    }
  }
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  display: none;

  &.timeline-header-time {
    .item {
      background-color: $gray-400;
      color: $black;
      padding: 4px 8px;
      font-size: $font-size-sm;
    }
  }
}

.timeline-body {
  position: relative;

  .message {
    position: absolute;
    bottom: 20%;
    left: 0;
    right: 0;
    text-align: center;
  }
}

.event-container {
  display: flex;
  border-bottom: 1px solid $gray-100;
  padding: $spacer $spacer * 1.5;

  .event-type {
    flex: 0 0 100px;
    padding-right: $spacer * 2;
    text-align: right;
    color: $gray-700;
  }

  .event-timeline {
    flex: 1 0 auto;
    display: flex;
    position: relative;

    .timeline {
      height: 20px;
    }

    .text-message {
      text-align: center;
      width: 100%;
    }
  }

  &.event-header {
    border-bottom: 2px solid $gray-200;
    padding-bottom: $spacer * 0.5;
    .event-timeline-container {
      margin-left: 100px;
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;

      .event-date, .event-time {
        display: flex;
        justify-content: space-between;
        .timeline {
          font-size: $font-size-sm;
          height: auto;
        }
      }

      .event-time {
        .timeline {
          &:first-child, &:last-child {
            color: $gray-700;
            font-size: $font-size-base;
          }
        }
      }
    }
  }

  &.event-all {
    border: none;

    .event-timeline {
      .timeline {
        flex: 1 0 auto;
        background-color: $gray-500;
      }
    }
  }

  &.event-buffer {
    .event-timeline {
      .timeline {
        position: absolute;
        background-color: $warning;
      }
    }
  }

  &.event-seeking {
    .event-timeline {
      .timeline {
        position: absolute;
        background-color: $blue;
      }
    }
  }

  &.event-error {
    .event-timeline {
      .timeline {
        position: absolute;
        background-color: $danger;
      }
    }
  }

  &.event-resolution {
    .event-timeline {
      .resolution {
        border-radius: 0;
      }
    }
  }

  &:not(.event-header):nth-child(even) {
    background-color: lighten($gray-100, 1%);
  }
}

.event-container-body {
  position: relative;

  .event-overlay {
    padding: 0;
    height: 100%;
    position: absolute;
    top: 0;
    left: 124px;
    bottom: 0;
    right: 0;
    background: none !important;
    pointer-events: none;

    .event-overlay-timeline {
      position: relative;
      width: 100%;
      height: 100%;

      .overlay {
        pointer-events: all;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        // background-color: rgba(0, 0, 0, 0.8);
        background: repeating-linear-gradient(
          -45deg,
          rgba(0, 0, 0, 0.5),
          rgba(0, 0, 0, 0.5) 10px,
          rgba(0, 0, 0, 0.6) 10px,
          rgba(0, 0, 0, 0.6) 20px
        );

        display: flex;

        justify-content: center;
        align-items: center;
      }
    }

    .btn-load {
      color: white;
      font-size: $font-size-lg;
    }
  }
}


.event-graph-container {
  .event-timeline {
    .max-value {
      font-size: $font-size-sm * 0.875;
      position: absolute;
      top: -10px;
    }
  }
}

#graph-container {
  width: 100%;
}

@media (max-width: 575.98px) {
  .event-container {
    padding: $spacer * 0.75;
    padding-top: $spacer * 2;
    position: relative;

    .event-type {
      position: absolute;
      top: $spacer * 0.5;
      font-size: $font-size-sm;
    }

    .event-timeline {
      height: 20px;
    }

    &.event-header {
      padding-top: $spacer * 0.75;
      .event-timeline-container {
        margin-left: 0;
      }
    }

    &.event-all {
      padding-top: $spacer * 0.75;
    }
  }

  .event-graph-container {
    height: 80px;

    .event-type {
      display: flex;
      align-items: center;
    }

    .event-timeline {
      .max-value {
        font-size: $font-size-sm * 0.875;
        position: absolute;
        top: -22px;
        right: 0;
      }
    }
  }

  .event-container-body {
    position: relative;
  }
}

</style>
